import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { PageProgressService } from '../services/page-progress.service';

/// Tells the loading bar about the requests a page makes while it opens (PageProgressService decides which count).
@Injectable()
export class PageProgressInterceptor implements HttpInterceptor {
    constructor(private progress: PageProgressService, @Inject(PLATFORM_ID) private platformId: any) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!isPlatformBrowser(this.platformId) || !this.progress.begin()) {
            return next.handle(req);
        }
        return next.handle(req).pipe(finalize(() => this.progress.done()));
    }
}
